import React, { useContext } from 'react'
import { Card, CardContent, Table, TableBody, TableContainer, TableHead, TableRow } from '@material-ui/core'
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles'
import { DailyMonitoringDetailsFiltersContext } from '../../../../../context/DailyMonitoringDetailsFiltersContext'
import DefaultTableCell from '../../../../../components/DefaultTableCell'
import DailyCheckoutOrdersTotal from './DailyCheckoutOrdersTotal'
import DailyOrdersTotal from './DailyOrdersTotal'
import DailyOrdersQuantity from './DailyOrdersQuantity'
import DailyOrdersAverage from './DailyOrdersAverage'
import DailyOrdersPercentageHistory from './DailyOrdersPercentageHistory'
import { getDaysInMonth, DaysInMonth } from '../../../../../utils/Helpers'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      marginTop: theme.spacing(2)
    }
  })
)

export default function DailyTotals (): JSX.Element {
  const classes = useStyles()
  const { filters } = useContext(DailyMonitoringDetailsFiltersContext)

  return (
    <Card className={classes.root}>
      <CardContent>
        <TableContainer>
          <Table size="small">
            <TableHead>
              <TableRow>
                <DefaultTableCell style={{ width: 240 }}></DefaultTableCell>
                {getDaysInMonth(filters.date.year, filters.date.month).map((day: DaysInMonth) => {
                  return <DefaultTableCell key={day.date} className={day.isWeekend ? 'weekend' : ''}>{day.date}</DefaultTableCell>
                })}
              </TableRow>
            </TableHead>
            <TableBody>
              <DailyCheckoutOrdersTotal />
              <DailyOrdersTotal />
              <DailyOrdersQuantity />
              <DailyOrdersAverage />
              <DailyOrdersPercentageHistory />
            </TableBody>
          </Table>
        </TableContainer>
      </CardContent>
    </Card>
  )
}
